import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSliderChange } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-edge-dialog',
  templateUrl: './edge-dialog.component.html',
})
export class EdgeDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EdgeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      width: [
        this.data.data.width, []
      ],
      length: [
        this.data.data.length , []
      ],
      depth: [
        this.data.data.depth , []
      ],
    });

    this.onFormChange();
  }

  private onFormChange() {
    this.form.valueChanges.subscribe((field) => {
    });
  }

  handleWidthChange($event: MatSliderChange) {
    this.form.get('width').setValue($event.value);
  }

  handleLengthChange($event: MatSliderChange) {
    this.form.get('length').setValue($event.value);
  }

  handleDepthChange($event: MatSliderChange) {
    
    this.form.get('depth').setValue($event.value);
  }

  handleInputChange(type: string, $event){
    let input: HTMLInputElement = <HTMLInputElement>$event.target;

    if (input.value === null || input.value === '') {
      return false;
    }
    let val = parseFloat(input.value);

    if (type === 'length') {
      if (val <= 0) {
        val = 0.1;
      } if (val > 6) {
        val = 6;
      }
      this.form.get(type).setValue(val * 1000);

    } else if (type === 'width') {
      if (val <= 0) {
        val = 1;
      } else if (val > 50) {
        val = 50;
      }
      this.form.get(type).setValue(val);

    } else if (type === 'depth') {
      if (val <= 0) {
        val = 1;
      } else if (val > 200) {
        val = 200;
      }
      this.form.get(type).setValue(val);
    }
    input.value = val.toString();
  }

  handleOkClose() {
    this.dialogRef.close({
      status: 'OK',
      index: this.data.index,
      type: this.data.type,
      data: {
        width: this.form.get('width').value,
        length: this.form.get('length').value,
        depth: this.form.get('depth').value,
      }
    });
  }

}
